import { Navigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { useAuth } from '../../contexts/auth-context'

export function CompanyGuard({ children }) {
	const { user, loading, hasCompanyAssignment, roleCheckComplete, pendingPasswordReset } = useAuth()

	// Wait for both initial loading and role check to complete
	if (loading || !roleCheckComplete) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
			</Box>
		)
	}

	if (pendingPasswordReset) {
		return <Navigate to="/reset-password" replace />
	}

	if (!user) {
		return <Navigate to="/auth" replace />
	}

	if (!hasCompanyAssignment) {
		return <Navigate to="/no-company" replace />
	}

	return children
}
